var assign = require('./assign')

/**
 * 该方法已废弃，被 assign 替换
 * @param target 目标对象
 * @param sources 多个对象
*/
var extend = assign

module.exports = extend



//////////////////
// WEBPACK FOOTER
// ./node_modules/xe-utils/methods/object/extend.js
// module id = GEqi
// module chunks = 0